import { FC, PropsWithChildren } from "react";

interface Props {
  title: string;
  closeHandler: () => void;
}

const ModalSearchContainer: FC<PropsWithChildren<Props>> = ({
  title,
  closeHandler,
  children,
}) => {
  return (
    <div className="fixed inset-0 bg-white z-modal w-full overflow-y-croll">
      <header className="sticky top-0 inset-x-0 flex justify-between items-center p-12">
        <p className="font-bold">{title}</p>
        <button className="text-xs" onClick={closeHandler}>
          <i className="Icon icon-Close" />
        </button>
      </header>

      {children}
    </div>
  );
};
export default ModalSearchContainer;
